import { gql } from "@apollo/client";

const getProfileNotesWebsocketTokenQuery = gql`
  query GetProfileNotesWebsocketTokenQuery($profileId: Int!) {
    user(userId: $profileId) {
      id
      profilePrivateNotesWebsocketToken
    }
  }
`;

export default getProfileNotesWebsocketTokenQuery;
